import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ModuleLoader } from '@wix/thunderbolt-renderer-utils'
import { ImportMapSymbol, PromiseCacheSymbol } from './symbols'
import type { ImportMap, IPromiseCache } from './types'
import type { BrowserWindow, Experiments, ILogger } from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol, ExperimentsSymbol, LoggerSymbol } from '@wix/thunderbolt-symbols'

export const ESMLoaderFactory = withDependencies(
	[PromiseCacheSymbol, BrowserWindowSymbol, ImportMapSymbol, LoggerSymbol, ExperimentsSymbol],
	(
		promiseCache: IPromiseCache,
		browserWindow: BrowserWindow,
		importMap: ImportMap,
		logger: ILogger,
		experiments: Experiments
	): ModuleLoader => {
		const scriptsCache: Record<string, any> = {}
		return {
			prefetchScript: (_url) => {
				// not implemented for esm
			},
			loadModule: async (url) => {
				const cached = scriptsCache[url]
				if (cached) {
					return cached
				}

				return promiseCache.runWithCache(url, async () => {
					const importMapBootstrapPromise = importMap.bootstrap()
					if (importMapBootstrapPromise) {
						await importMapBootstrapPromise
					}
					// if importShim is available, this means the shim has run so we need to use it
					const dynamicImport = browserWindow?.importShim ?? ((url: string) => import(/* webpackIgnore: true */ url))

					if (experiments['specs.thunderbolt.fixBuilderHierarchyLoadingRace']) {
						logger.interactionStarted('esm-module-load')
						try {
							const module = await dynamicImport(url)
							scriptsCache[url] = module
							return module
						} finally {
							logger.interactionEnded('esm-module-load')
						}
					} else {
						logger.interactionStarted('esm-module-load')
						const module = await dynamicImport(url)
						logger.interactionEnded('esm-module-load')

						scriptsCache[url] = module
						return module
					}
				})
			},
		}
	}
)
